const initialState = {
  expandedItems: [],
};

const shopAccordionReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_EXPANDED_ITEMS':
      return {
        ...state,
        expandedItems: action.payload,
      };
    default:
      return state;
  }
};

export { initialState, shopAccordionReducer };
